import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import ConfirmDeleteModal from 'chairisher/component/modal/confirmdelete';
import NavigationView from 'chairisher/view/navigation';
import ProductUpdateView from 'chairisher/view/product/edit';
import VariantEditView from 'chairisher/view/product/variant/edit';

import { getUrlHash } from 'chairisher/context/tracking';
import { getMetaObject, getProductObject } from 'chairisher/context/listingflow';

/**
 * Controller that binds actions for product creation and updating
 */
class ProductUpdateController extends BaseController {
    /** @inheritDoc * */
    bindPageActions() {
        this.productUpdateView = new ProductUpdateView({
            metaObject: getMetaObject(),
            productObject: getProductObject(),
        });

        const variantEditView = new VariantEditView('.js-update-variant');
        variantEditView.bindTrigger();

        ConfirmDeleteModal.bind('.js-variant-unlink-action');

        // scroll to element (by class) if #anchor is present in URL
        let urlHash = getUrlHash();
        urlHash = urlHash && urlHash.substring(1);
        const $anchorElement = urlHash && $(`.${urlHash}`);
        if ($anchorElement && $anchorElement.length) {
            const additionalOffset = $('.js-wizard-nav').outerHeight();
            NavigationView.scrollToElement($anchorElement, additionalOffset);
        }
    }
}

export default ProductUpdateController;
